import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import * as router from 'react-router-dom';
import {Container} from 'reactstrap';
import './Style.css'
import {
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav, AppSidebarMinimizer,
} from '@coreui/react';
// sidebar nav config
import navigation from '../../_corporate_nav';
import visitorTagNavigation from '../../_visitor_tag_nav';
import navigationSpace from '../../_space_nav';
import navigationEvent from '../../_eventtag_tag_nav';
// routes config
import routes from '../../routes';
import './Style.css'
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import Cookies from "js-cookie";

import DefaultHeader from "./CorporateHeader";
import DefaultFooter from "../DefaultLayout/DefaultFooter";
import {PropagateLoader} from "react-spinners";
import JWT_Decode from "jwt-decode";
import axiosTags from "../../axios/axios_tag";
import apiConfig from "../../axios/axios_api_services";
import * as common from "../../const/Common/CommonFunc";


class CorporateLayout extends Component {
  state = {
    loader: true
  };

  loading = () => <span/>;
  manageIframe = () => {
    this.setState({
      loader: false
    })
  };
  getAllDashboards = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.get(apiConfig.CORPORATE_DASHBOARD(id), {headers: headers})
      .then(response => {
        if (response.data.success) {

          let result = response.data.dashboardCards;
          const data = {branchCount: 0, departmentCount: 0, buildingsCount: 0};

          if (result && result.length !== 0) {
            result.map((obj, index) => {
              if (obj.name.indexOf("Departments") !== -1) {
                data.departmentCount = obj.count
              }
              if (obj.name.indexOf("Branches") !== -1) {
                data.branchCount = obj.count
              }
              if (obj.name.indexOf("Buildings") !== -1) {
                data.buildingsCount = obj.count
              }
            })
          }

          const obj = {
            // isActiveVisitor: !(data.branchCount === 0 || data.departmentCount === 0 || data.buildingsCount === 0),
            branchCount: data.branchCount,
            departmentCount: data.departmentCount,
            buildingsCount: data.buildingsCount,
          };
          this.props.addTagsDashboard(obj);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllDashboards(id);
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };

  signOut(e) {
    e.preventDefault();
    Cookies.remove("3c8bed3b2d6ba6d3076ee8d2f588a4dd");
    Cookies.remove("68a6102f6ed24899420170004a0273b8");
    this.props.history.push('/login')
  }

  componentWillMount() {
    let user_obj = Cookies.get("3c8bed3b2d6ba6d3076ee8d2f588a4dd");
    if (user_obj !== undefined) {

      this.props.userHandler(JSON.parse(user_obj));

      // for parktags -----------------------------------------------
      let token = Cookies.get("68a6102f6ed24899420170004a0273b8");
      let decode_token = JWT_Decode(token);

      decode_token.user = JSON.parse(user_obj);
      decode_token.access_token = Cookies.get("68a6102f6ed24899420170004a0273b8");
      decode_token.refresh_token = Cookies.get("9b8558ba3f051677daf36ebfc67f29fa");
      this.getAllDashboards(decode_token.user.corporateId);

      decode_token.userId = decode_token.user.userId;
      decode_token.userRoles = decode_token.user.userRoles;
      decode_token.corporates = decode_token.user.corporates;

      sessionStorage.setItem("userData", JSON.stringify(decode_token));

      localStorage.setItem("userData", JSON.stringify(decode_token));
      localStorage.setItem("userId", decode_token.user.userId);
      localStorage.setItem("userRoles", decode_token.user.userRoles);

      // -----------------------------------------------------------

    } else {
      this.props.history.push("/");
    }
  }

  render() {
    let type = this.props.system_changer;
    if (type === 5)
      document.title = "Miracle Dome";
    if (type === 3)
      document.title = "Miracle Dome";
    if (type === 2)
      document.title = "Miracle Dome";
    if (type === 1)
      document.title = "Miracle Dome";

    return (
      <div className="app">
        <AppHeader fixed>
          <DefaultHeader onLogout={e => this.signOut(e)}/>
        </AppHeader>

        {
          this.props.system_changer === 1 ?
            <div className="app-body">
              <AppSidebar className="navBarWidth" fixed display="lg">
                <AppSidebarHeader/>
                <AppSidebarForm/>

                <AppSidebarNav className="navBarWidth" navConfig={navigation} {...this.props} router={router}/>

                <AppSidebarFooter/>
                <AppSidebarMinimizer/>
              </AppSidebar>
              <main className="main margin-left239">
                <AppBreadcrumb appRoutes={routes} router={router}/>
                <Container fluid>

                  <Switch>
                    {routes.map((route, idx) => {
                      return route.component ? (
                        <Route
                          key={idx}
                          path={route.path}
                          exact={route.exact}
                          name={route.name}
                          render={props => (
                            <route.component {...props} />
                          )}/>
                      ) : (null);
                    })}
                  </Switch>

                </Container>
              </main>

            </div>
            :
            this.props.system_changer === 2 ?
              <div className="app-body">
                <AppSidebar className="navBarWidth" fixed display="lg">
                  <AppSidebarHeader/>
                  <AppSidebarForm/>

                  <AppSidebarNav className="navBarWidth" navConfig={visitorTagNavigation} {...this.props}
                                 router={router}/>

                  <AppSidebarFooter/>
                  <AppSidebarMinimizer/>
                </AppSidebar>
                <main className="main margin-left239">
                  <AppBreadcrumb appRoutes={routes} router={router}/>
                  <Container fluid>

                    <Switch>
                      {routes.map((route, idx) => {
                        return route.component ? (
                          <Route
                            key={idx}
                            path={route.path}
                            exact={route.exact}
                            name={route.name}
                            render={props => (
                              <route.component {...props} />
                            )}/>
                        ) : (null);
                      })}
                    </Switch>

                  </Container>
                </main>

              </div>
              :
              this.props.system_changer === 3 ?
                <div className="app-body">
                  {
                    this.state.loader ?
                      <div>
                        <div className="ant-modal-mask" style={{background: 'rgba(239, 239, 239, 0.4)'}}>
                        </div>

                        <div tabIndex="-1" style={{zIndex: '10000'}} className="ant-modal-wrap vertical-center-modal"
                             role="dialog">
                          <div className={"wrap-sweet-loading"}>
                            <div className='sweet-loading'>
                              <PropagateLoader
                                sizeUnit={"px"}
                                size={this.props.size ? this.props.size : 15}
                                color={this.props.color ? this.props.color : '#0085ca'}
                                loading={this.state.loading}
                              />
                            </div>

                          </div>
                        </div>
                      </div>
                      : null
                  }
                  <iframe src="/parktags/index.html" className={"iframe-tags parktags-iframe"} id={"iframe"}
                          onLoad={this.manageIframe}/>
                </div>
                :
                this.props.system_changer === 4 ?
                  <div className="app-body">
                    <AppSidebar className="navBarWidth" fixed display="lg">
                      <AppSidebarHeader/>
                      <AppSidebarForm/>

                      <AppSidebarNav className="navBarWidth" navConfig={navigationEvent} {...this.props}
                                     router={router}/>

                      <AppSidebarFooter/>
                      <AppSidebarMinimizer/>
                    </AppSidebar>
                    <main className="main margin-left239">
                      <AppBreadcrumb appRoutes={routes} router={router}/>
                      <Container fluid>

                        <Switch>
                          {routes.map((route, idx) => {
                            return route.component ? (
                              <Route
                                key={idx}
                                path={route.path}
                                exact={route.exact}
                                name={route.name}
                                render={props => (
                                  <route.component {...props} />
                                )}/>
                            ) : (null);
                          })}
                        </Switch>

                      </Container>
                    </main>

                  </div>
                :
                this.props.system_changer === 5 ?
                  <div className="app-body">
                    <AppSidebar className="navBarWidth" fixed display="lg">
                      <AppSidebarHeader/>
                      <AppSidebarForm/>

                      <AppSidebarNav className="navBarWidth" navConfig={navigationSpace} {...this.props}
                                     router={router}/>

                      <AppSidebarFooter/>
                      <AppSidebarMinimizer/>
                    </AppSidebar>
                    <main className="main margin-left239">
                      <AppBreadcrumb appRoutes={routes} router={router}/>
                      <Container fluid>

                        <Switch>
                          {routes.map((route, idx) => {
                            return route.component ? (
                              <Route
                                key={idx}
                                path={route.path}
                                exact={route.exact}
                                name={route.name}
                                render={props => (
                                  <route.component {...props} />
                                )}/>
                            ) : (null);
                          })}
                        </Switch>

                      </Container>
                    </main>

                  </div>
                :null
        }

        {
          this.props.system_changer !== 3 ?
            <AppFooter>
              <DefaultFooter ROLE={"CORPORATE"}/>
            </AppFooter>
            : null
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  system_changer: state.systemChangeReducer.system_changer
});

const mapDispatchToProps = (dispatch) => {
  return {
    systemChangeHandler: (data) => dispatch(actionCreator.systemChangeHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // dashboard details handler
    addTagsDashboard: (data) => dispatch(actionCreator.addTagsDashboard(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CorporateLayout);
